const indexComponent = require('./components/Checkout');

const indexRoute = {
  component: indexComponent,
};

module.exports = {
  path: 'checkout',
  getIndexRoute(partialNextState, cb) {
    require.ensure([], () => {
      cb(null, indexRoute);
    });
  },
};



// WEBPACK FOOTER //
// ./routes/checkout/index.js